<template>
    <i v-if="type" :class="'iconfont icon-' + type" :style="'font-size:' + size + 'px;color:' + color + ';'"></i>
</template>

<script>
export default {
    props: {
        size: {
            type: [Number,String],
            default: 20
        },
        type: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: '#222'
        }
    }
}
</script>

<style>
/* @import '//at.alicdn.com/t/c/font_4947273_0cknf2fjy63e.css' */
@import '//at.alicdn.com/t/c/font_5000872_ir3rredhz8.css'
</style>